/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import TaggerInserterConfiguration from 'embercom/objects/series/node/tagger-inserter-configuration';

export default class TaggerNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new TaggerInserterConfiguration();
  category = NODE_CATEGORIES.action;
}
